import { useParams } from 'react-router-dom';
import { VariantConfiguratorProvider } from './VariantConfiguratorContext';
import VariantConfiguratorTabRenderer from './VariantConfiguratorTabRenderer';

type PageParams = {
    variantConfiguratorId: string;
};

const VariantConfiguratorDetailsPage = () => {
    const { variantConfiguratorId } = useParams<PageParams>();

    return (
        <VariantConfiguratorProvider variantConfiguratorId={variantConfiguratorId}>
            <VariantConfiguratorTabRenderer />
        </VariantConfiguratorProvider>
    );
};

export default VariantConfiguratorDetailsPage;
